import { db } from "../firebase-config";
import { doc, getDoc, setDoc } from "firebase/firestore";


export const getStripeInvoiceSettings = async (organizationId) => {
    try {
        const settingsRef = doc(db, "organizations", organizationId, "stripe_information", "stripe_invoice_settings");
        const settingsSnap = await getDoc(settingsRef);
        
        if (settingsSnap.exists()) {
            return { success: true, data: settingsSnap.data() };
        }
        
        // Return default settings if none exist
        return { 
            success: true, 
            data: {
                primaryColor: '#000000',
                secondaryColor: '#ffffff',
                logoUrl: '',
                defaultCurrency: 'usd',
                defaultFooter: '',
                defaultMemo: '',
                customFields: [],
                taxDisplay: 'inclusive',
                paymentTerms: 30,
                statementDescriptor: '',
                statementDescriptorKana: '',
                statementDescriptorKanji: '',
                paymentMethodTypes: ['card'],
                acceptedPaymentMethods: ['card', 'bank_transfer']
            }
        };
    } catch (error) {
        console.error("Error getting stripe settings:", error);
        return { success: false, error: error.message };
    }
};

export const updateStripeInvoiceSettings = async (organizationId, settings) => {
    try {
        const settingsRef = doc(db, "organizations", organizationId, "stripe_information", "stripe_invoice_settings");
        await setDoc(settingsRef, settings, { merge: true });
        return { success: true };
    } catch (error) {
        console.error("Error updating stripe settings:", error);
        return { success: false, error: error.message };
    }
}; 